import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  visitTypeCategories: [],
  selectedVisitTypeCategory: null,
  loading: false,
  error: null,
  successMessage: null,
  // Pagination
  page: 1,
  pageSize: 10,
  total: 0,
  // Sorting
  sortColumn: 'name',
  sortDirection: 'asc',
  // Filtering
  filterName: '',
};

const visitTypeCategoriesSlice = createSlice({
  name: 'visitTypeCategories',
  initialState,
  reducers: {
    // Fetch visit type categories
    fetchVisitTypeCategories: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchVisitTypeCategoriesSuccess: (state, action) => {
      state.loading = false;
      state.visitTypeCategories = action.payload.data;
      state.total = action.payload.meta.total;
      state.error = null;
    },
    fetchVisitTypeCategoriesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Fetch visit type category by ID
    fetchVisitTypeCategoryById: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchVisitTypeCategoryByIdSuccess: (state, action) => {
      state.loading = false;
      state.selectedVisitTypeCategory = action.payload;
      state.error = null;
    },
    fetchVisitTypeCategoryByIdFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Add visit type category
    addVisitTypeCategory: (state) => {
      state.loading = true;
      state.error = null;
    },
    addVisitTypeCategorySuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    addVisitTypeCategoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update visit type category
    updateVisitTypeCategory: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateVisitTypeCategorySuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    updateVisitTypeCategoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Delete visit type category
    deleteVisitTypeCategory: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteVisitTypeCategorySuccess: (state, action) => {
      state.loading = false;
      state.visitTypeCategories = state.visitTypeCategories.filter((vtc) => vtc.id !== action.payload);
      state.error = null;
      state.successMessage = action.payload.message;
    },
    deleteVisitTypeCategoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Bulk delete
    bulkDeleteVisitTypeCategories: (state) => {
      state.loading = true;
      state.error = null;
    },
    bulkDeleteVisitTypeCategoriesSuccess: (state, action) => {
      state.loading = false;
      state.visitTypeCategories = state.visitTypeCategories.filter((vtc) => !action.payload.includes(vtc.id));
      state.error = null;
      state.successMessage = action.payload.message;
    },
    bulkDeleteVisitTypeCategoriesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Pagination
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.page = 1;
    },

    // Sorting
    setSortColumn: (state, action) => {
      state.sortColumn = action.payload;
    },
    setSortDirection: (state, action) => {
      state.sortDirection = action.payload;
    },

    // Filtering
    setFilterName: (state, action) => {
      state.filterName = action.payload;
      state.page = 1;
    },

    // Clear messages
    clearError: (state) => {
      state.error = null;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
  },
});

export const {
  fetchVisitTypeCategories,
  fetchVisitTypeCategoriesSuccess,
  fetchVisitTypeCategoriesFailure,
  fetchVisitTypeCategoryById,
  fetchVisitTypeCategoryByIdSuccess,
  fetchVisitTypeCategoryByIdFailure,
  addVisitTypeCategory,
  addVisitTypeCategorySuccess,
  addVisitTypeCategoryFailure,
  updateVisitTypeCategory,
  updateVisitTypeCategorySuccess,
  updateVisitTypeCategoryFailure,
  deleteVisitTypeCategory,
  deleteVisitTypeCategorySuccess,
  deleteVisitTypeCategoryFailure,
  bulkDeleteVisitTypeCategories,
  bulkDeleteVisitTypeCategoriesSuccess,
  bulkDeleteVisitTypeCategoriesFailure,
  setPage,
  setPageSize,
  setSortColumn,
  setSortDirection,
  setFilterName,
  clearError,
  clearSuccessMessage,
} = visitTypeCategoriesSlice.actions;

// Selectors
export const selectVisitTypeCategories = (state) => state.visitTypeCategories?.visitTypeCategories || [];
export const selectSelectedVisitTypeCategory = (state) => state.visitTypeCategories?.selectedVisitTypeCategory;
export const selectVisitTypeCategoriesLoading = (state) => state.visitTypeCategories?.loading || false;
export const selectVisitTypeCategoriesError = (state) => state.visitTypeCategories?.error;
export const selectVisitTypeCategoriesSuccessMessage = (state) => state.visitTypeCategories?.successMessage;
export const selectVisitTypeCategoriesTotal = (state) => state.visitTypeCategories?.total || 0;
export const selectVisitTypeCategoriesPage = (state) => state.visitTypeCategories?.page || 1;
export const selectVisitTypeCategoriesPageSize = (state) => state.visitTypeCategories?.pageSize || 10;
export const selectVisitTypeCategoriesSortColumn = (state) => state.visitTypeCategories?.sortColumn || 'name';
export const selectVisitTypeCategoriesSortDirection = (state) => state.visitTypeCategories?.sortDirection || 'asc';
export const selectVisitTypeCategoriesFilterName = (state) => state.visitTypeCategories?.filterName || '';

export default visitTypeCategoriesSlice.reducer;

